import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class TemplateSectionService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private templateSectionUrl = this.baseApiUrl + '/api/v1/template_section';
  private templateSectionTypeUrl = this.baseApiUrl + '/api/v1/template_section_type';

  list(params) {
    return this.http.get(`${this.templateSectionUrl}`, {params});
  }

  listSectionTypes(params) {
    return this.http.get(`${this.templateSectionTypeUrl}`, {params});
  }
}
